var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAddressOffice = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "52px",
    viewBox: "0 0 64 52",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1007.000000, -550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1009.000000, 551.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.54747351e-13,21.3075479 L-4.54747351e-13,10.5154039 C-4.54814986e-13,9.96311917 0.44771525,9.51540392 1,9.51540392 L58.8916817,9.51540392 C59.4439665,9.51540392 59.8916817,9.96311917 59.8916817,10.5154039 L59.8916817,21.3081368 C59.8916817,21.7661866 59.5804741,22.1656767 59.1363454,22.2777448 L30.2364394,29.5701319 C30.0760877,29.6105939 29.908204,29.6106554 29.7478227,29.5703109 L0.756046901,22.2773349 C0.311571303,22.1655257 -4.52766854e-13,21.7658708 -4.54747351e-13,21.3075479 Z",
    id: "Path-26",
    stroke: "#000000",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 23.4921536,
    y: 23.6798745,
    width: 13,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.54747351e-13,26.9741868 L-4.54747351e-13,45.779961 C-4.52781161e-13,47.4368152 1.34314575,48.779961 3,48.779961 L56.8916817,48.779961 C58.548536,48.779961 59.8916817,47.4368152 59.8916817,45.779961 L59.8916817,26.9741868 L59.8916817,26.9741868",
    id: "Path-27",
    stroke: "#000000",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9502717,5.24878246 L19.9502717,2 C19.9502717,0.8954305 20.8457022,2.02906125e-16 21.9502717,0 L38.4292612,0 C39.5338307,-2.02906125e-16 40.4292612,0.8954305 40.4292612,2 L40.4292612,5.24878246 L40.4292612,5.24878246",
    id: "Path-28",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddressOffice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/address-office.2909cbe9.svg";
export { ForwardRef as ReactComponent };